export const showUnsubscribeLink = (currentCountry, portalName) => {
    return !(
        currentCountry==='RO' && ['Gamistream', 'Fizzzplay', 'Jupistream', 'Dadastream'].includes(portalName)
    )
    && !(currentCountry==='FR')
    && !(currentCountry==='DE' && ['Fitlandclub'].includes(portalName))
    && !(
        currentCountry==='RS' && ['Runsio', 'Fizzzplay', 'Vemoplay', 'Bingenova'].includes(portalName)
    )
    && !(
        currentCountry==='RE' && ['Fitlandclub', 'Runsio'].includes(portalName)
    )
    && !(
        currentCountry==='CB' && ['Fitlandclub', 'Runsio'].includes(portalName)
    )
    && !(
      currentCountry === 'PL' && ['Fizzzplay', 'Bingenova', 'Loopivio'].includes(portalName)
    )
    && !(
      currentCountry === 'BG' && ['Fizzzplay'].includes(portalName)
    );
}
